import { http } from './../../../libs/util'
import util from '../../../libs/util'
const { 
    expense_nature_list,
    expense_nature_save,
    expense_nature_diable,
    customer_function_list,
    customer_function_save,
    customer_function_delete,
    item_type_list,
    item_type_save,
    item_type_delete,
    account_title_all,
    account_title_save,
    account_title_change_status,
    analysis_title_list,
    analysis_title_save,
    analysis_title_change_status,
    fund_usage_list,
    fund_usage_save,
    fund_usage_change_status
 } = util.api || {}
// 获取主体资质列表
export function getExpenseNatureListApi(params) {
    return http.get(expense_nature_list, params)
}

// 新增修改费用性质
export function addAndUpdateNatureApi(params) {
    return http.post(expense_nature_save, params)
}

// 费用nature停用或者启用
export function setExpenseNatureStatusApi(params) {
    return http.post(expense_nature_diable, params)
}

// 获取职能列表
export function getCustomerFunctionListApi(params) {
    return http.get(customer_function_list, params)
}

// 新增或编辑职能
export function setAddAndUpdateCustomerFunctionSaveApi(params) {
    return http.post(customer_function_save, params)
}

// 启用禁用职能
export function setcustomerFunctionStatusApi(params) {
    return http.post(customer_function_delete, params)
}

// 获取职能列表 item_type_list
export function getItemTypeListApi(params) {
    return http.get(item_type_list, params)
}

// 修改添加产品
export function addItemTypeApi(params) {
    return http.post(item_type_save, params)
}

// 启用禁用产品类型
export function setItemTypeStatusApi(params) {
    return http.post(item_type_delete, params)
}

// 查看会计科目
export function getAccountTitleAllApi(params) {
    return http.get(account_title_all, params)
}

// 新增编辑会计科目
export function addAccountTitleSaveApi(params) {
    return http.post(account_title_save, params)
}

// 修改科目启用禁用状态 account_title_change_status
export function changeAccountTitleStatusApi(params) {
    return http.post(account_title_change_status, params)
}

// 获取分析科目列表
export function getAnalysisTitleAllApi(params) {
    return http.get(analysis_title_list, params)
}

// 新增编辑分析科目
export function addAnalysisTitleSaveApi(params) {
    return http.post(analysis_title_save, params)
}

// 修改分析科目状态
export function changeAnalysisTitleStatusApi(params) {
    return http.post(analysis_title_change_status, params)
}

// 获取用途名称列表
export function getFundUseageListApi(params) {
    return http.get(fund_usage_list, params)
}

// 修改用途 fund_usage_save
export function setFundUsageSaveApi(params) {
    return http.post(fund_usage_save, params)
}

// 修改用途状态 fund_usage_change_status
export function changeFundUsageStatusApi(params) {
    return http.post(fund_usage_change_status, params)
}